import type { Pouch, PouchLayerValue } from '../types';

/** 時間パウチの内部値の絶対値（UI の「±60×」と対応） */
export const TIME_POUCH_BASE_VALUE = 60;

/** 実効分数（分）から ±60×mult の value/multiplier を作る */
export function timePouchStateFromEffectiveMinutes(
  requiredEffective: number,
): { value: number; multiplier: number } {
  const base = TIME_POUCH_BASE_VALUE;
  if (requiredEffective === 0) {
    return { value: base, multiplier: 0 };
  }
  const value = requiredEffective > 0 ? base : -base;
  const multiplier =
    Math.round((requiredEffective / value) * 1000000000) / 1000000000;
  return { value, multiplier };
}

/** 時間レイヤー entry の実効分数（value×multiplier） */
export function getTimeLayerEffectiveMinutes(
  entry: Pick<PouchLayerValue, 'value' | 'multiplier'>,
  fallbackMult: number,
): number {
  const m = entry.multiplier ?? fallbackMult;
  const val = entry.value;
  return m >= 0 ? val * m : val / Math.abs(m);
}

export function getTimePouchEffectiveMinutesFromState(
  p: Pick<Pouch, 'value' | 'multiplier' | 'isTime'>,
  multiplierOverride?: number,
): number {
  const m = multiplierOverride !== undefined ? multiplierOverride : p.multiplier;
  if (!p.isTime) return p.value;
  return m >= 0 ? p.value * m : p.value / Math.abs(m);
}

/** GTP 焼き付け後: 実効分数を bakeFactor 倍して ±60×mult に正規化 */
export function applyTimeEffectiveGtpBake(
  effectiveMinutes: number,
  bakeFactor: number,
): { value: number; multiplier: number } {
  return timePouchStateFromEffectiveMinutes(effectiveMinutes * bakeFactor);
}
